import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toDay } from "../lib/datetime";
import { isBefore } from "../offering/day_utils";
import { buildPathWithParams } from "./use_query_string";

interface DateProperties {
  startDate?: string;
  endDate?: string;
  date?: string;
  redirectURL?: string;
  partnerOfferingID: string;
}

export const usePassedDateRedirect = (dateProperties: DateProperties) => {
  const {
    startDate,
    endDate,
    date,
    partnerOfferingID,
    redirectURL = `/offerings/${partnerOfferingID}`,
  } = dateProperties;

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const isPassedStartDate =
      startDate && isBefore(startDate, toDay(new Date()));
    const isPassedEndDateDate = endDate && isBefore(endDate, toDay(new Date()));
    const isPassedDate = date && isBefore(date, toDay(new Date()));

    if (isPassedStartDate || isPassedEndDateDate || isPassedDate) {
      const pathWithParams = buildPathWithParams(redirectURL);
      const dateRemovedPathWithParams = removeSearchParams(pathWithParams, [
        "startDate",
        "endDate",
        "date",
        "startTime",
        "endTime",
      ]);

      history.replace(dateRemovedPathWithParams);
    }
  }, [
    date,
    endDate,
    history,
    location.search,
    partnerOfferingID,
    redirectURL,
    startDate,
  ]);
};

const removeSearchParams = (relativeUrl: string, paramsToRemove: string[]) => {
  // Just a dummy URL is enough to remove params from relativeURL
  const baseUrl = "https://dummy.com";
  const url = new URL(relativeUrl, baseUrl);

  paramsToRemove.forEach((param) => {
    url.searchParams.delete(param);
  });

  const updatedRelativeUrl = url.pathname + url.search;
  return updatedRelativeUrl;
};
